// Sample test vehicles data for development and testing
export var testVehicles = [
    {
        model: "Mazda2",
        badge: "1.5 Genki",
        manufacturer: "Mazda",
        manufactureYear: "2005",
        badgeCategoryID: "",
        bodyType: "Hatchback",
        cylinders: "4",
        description: "2005 Mazda Mazda2 1.5 Genki 5 Door Automatic FWD Hatchback MY05",
        doorCount: "5",
        driveType: "FWD",
        engineSize: "1.5",
        fuelTypeBasic: "Unleaded",
        fuelTypeBasicCategoryID: "",
        imageUrl: "https://static.kbb.com.au/pkw/p/MAZDA/MAZDA2/2005/5ha.jpg",
        manufacturerCategoryID: 54,
        modelCategoryID: 578,
        seatCount: 5,
        series: "MY05",
        seriesCategoryID: 0,
        thumbUrl: "https://static.kbb.com.au/pkw/s/MAZDA/MAZDA2/2005/5ha.jpg",
        transmissionTypeBasic: "Automatic With Manual Mode",
        transmissionTypeBasicCategoryID: "",
        variantCode: "4677"
    },
    {
        model: "Mazda2",
        badge: "1.5 Genki Activematic",
        manufacturer: "Mazda",
        manufactureYear: "2005",
        badgeCategoryID: "",
        bodyType: "Hatchback",
        cylinders: "4",
        description: "2005 Mazda Mazda2 1.5 Genki Activematic 5 Door Automatic FWD Hatchback MY05",
        doorCount: "5",
        driveType: "FWD",
        engineSize: "1.5",
        fuelTypeBasic: "Unleaded",
        fuelTypeBasicCategoryID: "",
        imageUrl: "https://static.kbb.com.au/pkw/p/MAZDA/MAZDA2/2005/5ha.jpg",
        manufacturerCategoryID: 54,
        modelCategoryID: 578,
        seatCount: 5,
        series: "MY05",
        seriesCategoryID: 0,
        thumbUrl: "https://static.kbb.com.au/pkw/s/MAZDA/MAZDA2/2005/5ha.jpg",
        transmissionTypeBasic: "Automatic With Manual Mode",
        transmissionTypeBasicCategoryID: "",
        variantCode: "9370"
    },
    {
        model: "Mazda2",
        badge: "1.5 Genki Auto",
        manufacturer: "Mazda",
        manufactureYear: "2005",
        badgeCategoryID: "",
        bodyType: "Hatchback",
        cylinders: "4",
        description: "2005 Mazda Mazda2 1.5 Genki Auto 5 Door Automatic FWD Hatchback MY04",
        doorCount: "5",
        driveType: "FWD",
        engineSize: "1.5",
        fuelTypeBasic: "Unleaded",
        fuelTypeBasicCategoryID: "",
        imageUrl: "https://static.kbb.com.au/pkw/p/MAZDA/MAZDA2/2004/5ha.jpg",
        manufacturerCategoryID: 54,
        modelCategoryID: 578,
        seatCount: 5,
        series: "MY04",
        seriesCategoryID: 0,
        thumbUrl: "https://static.kbb.com.au/pkw/s/MAZDA/MAZDA2/2004/5ha.jpg",
        transmissionTypeBasic: "Automatic",
        transmissionTypeBasicCategoryID: "",
        variantCode: "4678"
    },
    {
        model: "Mazda2",
        badge: "1.5 Neo Power & Safety Pack Auto",
        manufacturer: "Mazda",
        manufactureYear: "2005",
        badgeCategoryID: "",
        bodyType: "Hatchback",
        cylinders: "4",
        description: "2005 Mazda Mazda2 1.5 Neo Power & Safety Pack Auto 5 Door Automatic FWD Hatchback MY04",
        doorCount: "5",
        driveType: "FWD",
        engineSize: "1.5",
        fuelTypeBasic: "Unleaded",
        fuelTypeBasicCategoryID: "",
        imageUrl: "https://static.kbb.com.au/pkw/p/MAZDA/MAZDA2/2004/5ha.jpg",
        manufacturerCategoryID: 54,
        modelCategoryID: 578,
        seatCount: 5,
        series: "MY04",
        seriesCategoryID: 0,
        thumbUrl: "https://static.kbb.com.au/pkw/s/MAZDA/MAZDA2/2004/5ha.jpg",
        transmissionTypeBasic: "Automatic",
        transmissionTypeBasicCategoryID: "",
        variantCode: "13600"
    }
];
